import detectIE from './detectIE';

const fakeLocalStorage = {
	storage: {},
	setItem(key, value) {
		this.storage[key] = value;
	},
	removeItem(key) {
		delete this.storage[key];
	},
	getItem(key) {
		return this.storage[key];
	}
};

function simulateLocalStorageIfNeeded() {
	const IE = detectIE();
	if (IE === 10 || IE === 11) {
		return fakeLocalStorage;
	}

	return window.localStorage;
}

export default simulateLocalStorageIfNeeded();



// WEBPACK FOOTER //
// ./src/js/utils/localStorage.js